import React, { useState } from "react";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import { Form, FormControl } from "react-bootstrap";
import { FaPaperPlane } from "react-icons/fa";
import { Link } from "react-router-dom";

function Messages() {
  const [isActive, setIsActive] = useState("");
  const [activeUserId, setActiveUserId] = useState(null);
  const [message, setMessage] = useState("");
  const maxLength = 500;

  const handleChange = (e) => {
    const value = e.target.value.slice(0, maxLength);
    setMessage(value);
  };

  return (
    <Container fluid="lg" className="mt-5 margin_bottomfooter pt-5">
      <Row className="mb-5">
        <Col md={12}>
          <h6 className="fs-3 fw-bold">Message</h6>
        </Col>

        <Col md={12}>
          <Row className="itenary_tabs">
            {/* Left Sidebar */}
            <Col md={12} xl={12} xxl={12} className="mb-3">
              <div
                className="chat-card-sidebar card"
                style={{
                  borderRadius: "10px",
                  maxHeight: "92vh",
                  overflow: "hidden",
                  height: "88vh",
                }}
              >
                <div className="qoute_write">
                  <h5 className="mb-0 " style={{fontSize:'40px', color:'#09422d'}}>comming soon </h5>
                </div>
              </div>
            </Col>
            {/* <Col md={4} xl={4} xxl={3} className="mb-3">
              <div
                className="chat-card-sidebar card"
                style={{
                  borderRadius: "10px",
                  maxHeight: "92vh",
                  overflow: "hidden",
                  height: "88vh",
                }}
              >
                <div className="card-body">
                  <Tab.Container defaultActiveKey="direct-messages">
                    <div className="tablmassage safartabs">
                      <div className="overflow-auto w-100 hide-scrollbar">
                      <Nav variant="tabs" className="slider_profilemobilechatd-flex gap-2 flex-nowrap">
                        <Nav.Item>
                          <Nav.Link
                            eventKey="direct-messages"
                            className="chatFonts"
                          >
                            Direct Messages
                          </Nav.Link>
                        </Nav.Item>
                        <Nav.Item>
                          <Nav.Link
                            eventKey="quote-requests"
                            className="chatFonts"
                          >
                            Quote Request (0)
                          </Nav.Link>
                        </Nav.Item>
                      </Nav>
                      </div>
                    </div>

                    <Tab.Content className="mt-4">
                      <Tab.Pane eventKey="direct-messages">
                        <div className="chat-search-user mb-3 position-relative">
                          <input
                            type="text"
                            className="form-control searchChat"
                            placeholder="Search"
                            autoComplete="off"
                          />
                          <div className="secrchIcons">
                            <i className="fa-solid fa-magnifying-glass"></i>
                          </div>
                        </div>

                        <div className="chat-cardlist pt-3">
                          <Link
                            to="#"
                            id="user1"
                            className={`chat-link mb-3 d-block ${
                              activeUserId === "user1" ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveUserId("user1");
                              setIsActive("user1");
                            }}
                          >
                            <div className="chat-sidebar-user-card click_mobile">
                              <div className="d-flex gap-2 chat-user_message">
                                <img
                                  src="https://www.walkintothewild.in/storage/safarioperator/3/safarioperator1724330309.jpeg"
                                  alt=""
                                  className="rounded-circle user-icon"
                                />
                                <div className="chat-user_name">
                                  <h6
                                    className="fs-6 mb-0"
                                    style={{ color: "#4c4c4c" }}
                                  >
                                    User1
                                  </h6>
                                  <p
                                    className="mb-0 lastmassge"
                                    style={{ color: "#4c4c4c" }}
                                  >
                                    Empty
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                          <Link
                            to="#"
                            id="user2"
                            className={`chat-link mb-3 d-block ${
                              activeUserId === "user2" ? "active" : ""
                            }`}
                            onClick={() => {
                              setActiveUserId("user2");
                              setIsActive("user2");
                            }}
                          >
                            <div className="chat-sidebar-user-card click_mobile">
                              <div className="d-flex gap-2 chat-user_message">
                                <img
                                  src="https://www.walkintothewild.in/storage/safarioperator/3/safarioperator1724330309.jpeg"
                                  alt=""
                                  className="rounded-circle user-icon"
                                />
                                <div className="chat-user_name">
                                  <h6
                                    className="fs-6 mb-0"
                                    style={{ color: "#4c4c4c" }}
                                  >
                                    User2
                                  </h6>
                                  <p
                                    className="mb-0 lastmassge"
                                    style={{ color: "#4c4c4c" }}
                                  >
                                    Empty
                                  </p>
                                </div>
                              </div>
                            </div>
                          </Link>
                        </div>
                      </Tab.Pane>

                      <Tab.Pane eventKey="quote-requests">
                        <div className="chat-cardlist pt-3"></div>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>
              </div>
            </Col>

            <Col md={8} xl={8} xxl={9} className="d-md-block d-none">
              <div className="chat_box card h-100 p-3">
                <div className="card-body">
                  {activeUserId ? (
                    <div className="d-flex chat-message-header pb-4 justify-content-between border-bottom">
                      <div className="chat-profile d-flex align-items-center gap-3">
                        <div className="icons-show back-btn">
                          <i className="fa-solid fa-chevron-left"></i>
                        </div>
                        <Link to="#" style={{ color: "inherit" }}>
                          <img
                            src="https://www.walkintothewild.in/storage/safarioperator/40/safarioperator1723704767.jpg"
                            alt=""
                            className="rounded-circle user-icon"
                            style={{ width: "45px", height: "45px" }}
                          />
                          {activeUserId === "user1" ? "User1" : "User2"}
                        </Link>
                      </div>
                    </div>
                  ) : (
                    <div className="pb-4 border-bottom">
                      Select a user to start chatting
                    </div>
                  )}

                  {activeUserId && (
                    <>
                      <div
                        className="chat-message-container"
                        style={{
                          height: "64vh",
                          overflowY: "auto",
                          paddingTop: "6px",
                          position: "relative",
                        }}
                      ></div>

                      <div className="chat-send-message-form pt-3">
                        <Form id="chatmessageform">
                          <div className="lead emoji-picker-container w-100 submit_on_enter position-relative">
                            <div className="character-count">
                              <span id="char-count">
                                {maxLength - message.length}
                              </span>{" "}
                              characters remaining
                            </div>

                            <FormControl
                              as="textarea"
                              rows={1}
                              name="Chat[message]"
                              placeholder="Type a Message"
                              className="form-control chat-message-input submit_on_enter"
                              value={message}
                              onChange={handleChange}
                              maxLength={maxLength}
                            />
                            <div className="sendMassege">
                              <div className="chat-sendbtn d-flex justify-content-center align-items-center">
                                <FaPaperPlane
                                  size={20}
                                  color="#fff"
                                  style={{ cursor: "pointer" }}
                                />
                              </div>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Col> */}
          </Row>
        </Col>
      </Row>
    </Container>
  );
}

export default Messages;
